<template>
  <EmailVerificationNotComplete />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import EmailVerificationNotComplete from "@/components/Account/email/EmailVerificationNotComplete.vue";

const componentName = "EmailVerificationNotCompleteRoute";

export default defineComponent({
  name: componentName,
  components: { EmailVerificationNotComplete },
});
</script>
